import { Lever } from '../types/lever.type';

export type LeverStateModel = {
  formValue: Lever[];
  formValid: boolean;
  selectedField?: string[];
  selectedUuid?: string;
};

export class UpdateFormLevers {
  static readonly type = '[Lever] Update form levers';
  constructor(public payload: { value: Lever[]; valid: boolean }) {}
}
export class AddLever {
  static readonly type = '[Lever] Add Lever';
  constructor(public lever: Lever) {}
}
export class SetSelectedField {
  static readonly type = '[Lever] Set Selected Field';
  constructor(public field: string[]) {}
}

export class SendFilterUuid {
  static readonly type = '[Lever] SendFilterUuid';
  constructor(public uuid: string) {
  }
}
